/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The application features:
 *   * SITE_OPERATION
 *   * SITE_MANAGEMENT
 *   * SUBSCRIPTION
 *   * SERVICE
 *   * TRANSACTION
 *   * AUTH_SUPPORT
 *   * VEHICLE
 *   * TICKET
 *   * REPORTING
 *   * USER
 *   * OCCUPANCY
 */
export enum ApplicationFeature {
  SITE_OPERATION = 'SITE_OPERATION',
  SITE_MANAGEMENT = 'SITE_MANAGEMENT',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SERVICE = 'SERVICE',
  TRANSACTION = 'TRANSACTION',
  AUTH_SUPPORT = 'AUTH_SUPPORT',
  VEHICLE = 'VEHICLE',
  TICKET = 'TICKET',
  USER = 'USER',
  REPORTING = 'REPORTING',
  OCCUPANCY = 'OCCUPANCY'
}
